import events from 'events.js';

(async function() {
    await events.ready();

    document.getElementById('div_id_specialty').classList.add('hide');
    document.getElementById('div_id_other_job_title').classList.add('hide');

    events.listen(document.getElementById('id_job_title'), 'change', function(
        e,
    ) {
        if (e.target.value === 'Pharmacist') {
            document
                .getElementById('div_id_clinical_software')
                .classList.add('hide');
            document
                .getElementById('div_id_other_job_title')
                .classList.add('hide');
            document.getElementById('div_id_specialty').classList.add('hide');
        } else if (e.target.value === 'Specialist') {
            document
                .getElementById('div_id_other_job_title')
                .classList.add('hide');
            document
                .getElementById('div_id_specialty')
                .classList.remove('hide');
            document
                .getElementById('div_id_clinical_software')
                .classList.remove('hide');
            document
                .getElementById('id_clinical_software')
                .removeAttribute('disabled');
        } else {
            if (e.target.value === 'Other') {
                document
                    .getElementById('div_id_other_job_title')
                    .classList.remove('hide');
            } else {
                document
                    .getElementById('div_id_other_job_title')
                    .classList.add('hide');
            }
            document.getElementById('div_id_specialty').classList.add('hide');
            document
                .getElementById('id_clinical_software')
                .removeAttribute('disabled');
            document
                .getElementById('div_id_clinical_software')
                .classList.remove('hide');
            document.getElementById('id_specialty').selectedIndex = 0;
        }
    });
})();
